// en/views/channelOta.js
export const channelOta = {
  common: {
    listing: "Annonce",
    back: "Retour",
    close: "Fermer",
    cancel: "Annuler",
    flexible: "Flexible",
    noResults: "Aucun résultat",
    deleteConn: "Supprimer la connexion",
  },
  head: {
    manage: "Gérer {channel}",
    airbnbConfig: "Paramètres Airbnb",
    channelOptions: "Options du canal",
  },
  picker: {
    placeholder: "Rechercher ou choisir une annonce…",
  },
  loading: {
    status: "Chargement du statut du canal…",
    listings: "Chargement de vos annonces Airbnb…",
    settings: "Chargement des paramètres de l'annonce…",
  },
  accounts: {
    title: "Sur lequel de vos comptes {channel} ?",
    lead: "Vous avez déjà un compte {channel} connecté. Vous pouvez y ajouter cette annonce ou connecter un autre compte. | Vous avez déjà {n} comptes {channel} connectés. Choisissez celui auquel appartient cette annonce, ou connectez-en un autre.",
    account: "Compte {n}",
    empty: "Pas encore d'annonces",
    andMore: "{list} et {rest} de plus",
    newTitle: "Connecter un autre compte {channel}",
    newDesc: "Pour les annonces qui sont sur un autre compte",
  },
  confirm: {
    title: "Supprimer la connexion {channel}",
    desc: "Le canal sera retiré du gestionnaire de canaux et de vos connexions actives.",
    coversPre: "Cette connexion couvre ",
    coversCount: "{count} annonce | {count} annonces",
    coversPost: " et sera déconnectée de toutes : {list}",
    purgePre: "Supprimer aussi les réservations importées ? Choisissez les chambres ",
    purgeNote: "(elles peuvent être récupérées)",
    selectAll: "Toutes",
    unselectAll: "Tout effacer",
    delete: "Supprimer",
    detachOnly: "Déconnecter uniquement cette annonce",
    deleteAll: "Supprimer et déconnecter {count} annonce | Supprimer et déconnecter les {count} annonces",
    deleteWithResv: "Supprimer (+{count} réservation) | Supprimer (+{count} réservations)",
  },
  gone: {
    title: "Cette connexion n'existe plus sur le canal",
    desc: "Le canal a été supprimé dans le gestionnaire de canaux. Supprimez cette connexion pour la reconnecter depuis “Connecter maintenant”.",
  },
  menu: {
    channelOptDesc: "Activez ou mettez en pause, modifiez le mappage, synchronisez, importez les réservations ou supprimez la connexion.",
    airbnbCfgDesc: "Horaires de check-in/out, préavis, prix et ménage pour chaque annonce.",
  },
  channel: {
    statusLabel: "Statut du canal",
    active: "Actif",
    inactive: "Inactif",
    deactivate: "Désactiver le canal",
    activate: "Activer le canal",
    pending: "En cours d'examen",
    hintPending: "Le canal est connecté et dispose déjà de vos données. Il doit encore examiner et accepter votre hébergement ; ensuite il s’active tout seul. Cela prend généralement quelques jours. Si c’est plus long, écrivez-nous et nous verrons.",
    hintActive: "Le canal est actif : nous envoyons les prix et la disponibilité. Désactivez-le pour suspendre l'envoi sans perdre le mappage.",
    blockersTitle: "Il manque quelque chose pour activer le canal",
    blockersHint: "Appuyez de nouveau sur « Connecter » dans l’assistant : nous corrigeons et renvoyons.",
    hintInactive: "Le canal est connecté mais en pause. Activez-le pour commencer à envoyer les prix et la disponibilité.",
    editTitle: "Modifier le canal",
    editDesc: "Modifiez ou ajoutez les chambres et plans tarifaires mappés à ce canal.",
    editBtn: "Modifier le mappage",
    fullSyncTitle: "Synchronisation complète",
    fullSyncDesc: "Renvoie tous les prix, disponibilités et restrictions au canal.",
    synced: "Synchronisé",
    sync: "Synchroniser",
    extractTitle: "Importer les réservations à venir",
    extractDesc: "Importez dans WACheckin les réservations que vous avez déjà sur le canal.",
    imported: "Importé",
    extract: "Importer",
    resyncTitle: "Réimporter les réservations",
    resyncDesc: "Récupère à nouveau toutes les réservations du canal et les réassigne selon le mappage actuel. Utilisez-le si vous avez choisi la mauvaise annonce ou si des réservations manquent.",
    resync: "Réimporter",
  },
  cfg: {
    emptyNoListings: "Vous n'avez encore associé aucune annonce. Allez dans <b>Options du canal → Modifier le mappage</b> pour connecter vos annonces Airbnb à vos unités.",
    emptyNoMapping: "Cet hébergement n'a encore aucune annonce Airbnb associée. Allez dans <b>Options du canal → Modifier le mappage</b> et associez son annonce pour définir ici ses horaires et ses prix.",
  },
  arrival: {
    section: "Arrivée et départ",
    lead: "À quelles heures et quels jours vos clients peuvent arriver et partir.",
    checkInFrom: "Check-in à partir de",
    checkInFromTip: "Heure la plus tôt à laquelle un client peut faire son check-in.",
    checkInTo: "Check-in jusqu'à",
    checkInToTip: "Heure la plus tardive à laquelle un client peut arriver.",
    checkOut: "Check-out",
    checkOutTip: "Heure la plus tardive à laquelle le client doit quitter l'hébergement.",
    unset: "Non défini",
    daysIn: "Jours où le check-in est autorisé",
    daysInTip: "Jours de la semaine où un client peut faire son check-in.",
    daysOut: "Jours où le check-out est autorisé",
    daysOutTip: "Jours de la semaine où un client peut faire son check-out.",
  },
  booking: {
    section: "Réservations",
    window: "Fenêtre de disponibilité",
    windowTip: "Jusqu'à quand votre calendrier s'ouvre à la vente. C'est ce qu'Airbnb appelle la 'fenêtre de disponibilité' (12 mois = 365 jours). Ce n'est PAS le nombre maximum de nuits par séjour.",
    minLead: "Préavis minimum",
    minLeadTip: "Combien de temps avant l'arrivée une réservation peut être faite. Évite les réservations de dernière minute.",
    maxStay: "Séjour maximum",
    maxStayTip: "Nombre maximum de nuits par réservation. C'est le 'nombre maximum de nuits' d'Airbnb, différent de la fenêtre de disponibilité.",
    turnover: "Jours entre les réservations",
    turnoverTip: "Jours bloqués entre un départ et le check-in suivant, pour nettoyer et préparer.",
  },
  rules: {
    section: "Règles de réservation",
    cancelPolicy: "Politique d'annulation",
    cancelPolicyTip: "Combien le client peut récupérer s'il annule. Flexible = plus souple ; Stricte = moins de remboursement.",
    whoCanBook: "Qui peut réserver",
    whoCanBookTip: "Qui peut réserver instantanément sans votre accord préalable.",
  },
  prices: {
    section: "Prix",
    perNight: "Prix par nuit",
    weekend: "Prix du week-end",
    weekendTip: "Prix pour le vendredi et le samedi. Laissez-le identique au prix par nuit si vous ne voulez pas de différence.",
    guestsIncluded: "Clients inclus",
    guestsIncludedTip: "Nombre de clients sans frais supplémentaires.",
    extraGuest: "Prix par client supplémentaire",
    extraGuestTip: "Coût par client supplémentaire, par nuit, au-delà de ceux inclus.",
  },
  cleaning: {
    section: "Ménage",
    notePre: "Remplissez les deux pour que chaque réservation paie le ménage. Les frais pour long séjour doivent être ",
    noteStrong: "supérieurs ou égaux",
    notePost: " à ceux pour court séjour. Si vous en laissez un à 0, ce type de séjour ne paiera pas le ménage.",
    long: "Ménage · long séjour",
    longTip: "Facturé pour les longs séjours. Doit être supérieur ou égal aux frais pour court séjour.",
    short: "Ménage · court séjour",
    shortTip: "Facturé pour les courts séjours (quelques nuits).",
    error: "Les frais de ménage pour long séjour ({sym}{long}) doivent être supérieurs ou égaux à ceux pour court séjour ({sym}{short}).",
  },
  tax: {
    section: "Taxe de séjour",
    lead: "Taxe locale que vous facturez au client et déclarez vous-même (pas Airbnb). Laissez 0 si elle ne s'applique pas.",
    amount: "Montant",
    amountTip: "Montant de la taxe. Mettez 0 pour ne pas l'appliquer.",
    charged: "Facturation",
    chargedTip: "Comment la taxe est calculée : par client et par nuit, par nuit, ou par client.",
    perGuestNight: "Par client et par nuit",
    perNight: "Par nuit",
    perGuest: "Par client",
    attestation: "Je confirme que ces informations sont correctes et que j'assume la responsabilité de facturer et de déclarer cette taxe.",
  },
  footer: {
    save: "Enregistrer les paramètres",
    saving: "Enregistrement…",
  },
  opts: {
    noticeNoLimit: "Aucune limite (toutes les dates)",
    months: "{count} mois | {count} mois",
    maxNoLimit: "Aucune limite",
    nights: "{count} nuit | {count} nuits",
    maxNights: "Maximum ({count})",
    cancelModerate: "Modérée",
    cancelFirm: "Ferme",
    cancelStrict: "Stricte",
    instantEveryone: "Tout client",
    instantWellReviewed: "Clients bien notés",
    instantVerified: "Identité vérifiée",
    instantReviewedVerified: "Avis + identité",
    leadNone: "Aucun préavis",
    hours: "{count} heure | {count} heures",
    days: "{count} jour | {count} jours",
  },
  msg: {
    loadSettingsError: "Impossible de charger les paramètres de l'annonce.",
    taxAttestationWarn: "Cochez la case d'attestation pour appliquer la taxe de séjour.",
    saveOk: "Paramètres Airbnb enregistrés et envoyés au canal.",
    saveError: "Impossible d'enregistrer les paramètres.",
    statusError: "Impossible de charger le statut du canal.",
    activated: "Canal activé.",
    deactivated: "Canal désactivé.",
    toggleError: "Impossible de modifier le statut du canal.",
    resyncOk: "Réservations réimportées : {imported}.",
    resyncOkWarn: "Réservations réimportées : {imported} ({errors} avec un avertissement).",
    resyncError: "Impossible de réimporter les réservations.",
    disconnectError: "Impossible de supprimer la connexion.",
    fullSyncOk: "Synchronisation complète envoyée.",
    extractOk: "Réservations à venir importées.",
    actionError: "Impossible d'exécuter l'action.",
  },
  rate: {
    apply: "Appliquer",
    or: "ou",
    usePlan: "utilisez l'un de vos tarifs…",
  },
};